import { AxiosInstance } from 'axios'

declare module 'axios' {
  export interface AxiosRequestConfig {
    expectedContentType?: string
  }
}

export function addContentTypeInterceptors(instance: AxiosInstance) {
  instance.interceptors.request.use(
    (config) => {
      const headers = config.headers || {}
      const acceptHeader: string =
        [headers.Accept, headers.accept].find((v) => typeof v === 'string') ??
        'application/json'

      let expectedContentType = 'application/json'

      const accepts = acceptHeader
        .split(',')
        .map((part) => {
          const [type, q] = part.split(';')
          return {
            type: type.trim(),
            q: q ? Number.parseFloat(q.split('=')[1]) : 1
          }
        })
        .sort((a, b) => b.q - a.q)

      if (accepts.length > 0 && accepts[0].type) {
        expectedContentType = accepts[0].type
      }

      return {
        ...config,
        expectedContentType
      }
    },
    (error: Error) => {
      return Promise.reject(error)
    }
  )

  instance.interceptors.response.use(
    (response) => {
      const { expectedContentType } = response.config
      if (expectedContentType) {
        const contentType =
          typeof response.headers['content-type'] === 'string'
            ? response.headers['content-type']
            : undefined

        if (!contentType && response.data) {
          return Promise.reject(
            new Error(
              `Fehlender Header "Content-Type" in Serverantwort: die Response beinhaltet einen Body, aber der Header "Content-Type" fehlt.`
            )
          )
        }

        if (contentType) {
          // example: "application/json;charset=UTF-8" -> "application/json"
          const normalizedContentType = contentType.split(';')[0].trim()

          if (
            normalizedContentType.toLowerCase() !==
            expectedContentType.toLowerCase()
          ) {
            return Promise.reject(
              new Error(
                `Unerwarteter Content-Type, erwartet wurde: ${expectedContentType.toLowerCase()}, erhalten: ${normalizedContentType.toLowerCase()}`
              )
            )
          }
        }
        return response
      }
      return Promise.reject(
        new Error(
          `Content-Type konnte nicht überprüft werden: fehlender expectedContentType in AxiosRequestConfig.`
        )
      )
    },
    (error: Error) => {
      return Promise.reject(error)
    }
  )
}
